<script lang="ts">
	//Stores
	import { alarms } from 'src/stores/lists/scenes-derived';
	//Services
	import { format } from 'svelte-i18n';
	//Design System Components
	import {
		Container,
		Icon,
		Modal,
		Stack,
		Text,
		ListItem,
		Button,
	} from '@Shelly/shelly-design-system/index';
	//Helpers
	import { load_image_from } from 'src/helpers/interface_helpers';
	import { checkIsAllAlarmsArmed, formatSecsToTimeString } from '../../list-helpers';
	//Types
	import type { IAlarmZone } from 'src/components/AlarmZones/AlarmWizard/alarm_object';

	export let showModal = false;
	export let alarmsDelayTimer: {
		[key: string]: number;
	} = {};

	let allAlarms: IAlarmZone[] = Object.values($alarms);

	const onCloseModal = () => {
		showModal = false;
	};

	$: allAlarms = Object.values($alarms);
	$: isAllArmed = checkIsAllAlarmsArmed(allAlarms);
</script>

<Modal
	title={isAllArmed
		? $format('label_alarms_armed', {
				default: 'Alarms Armed',
			})
		: $format('label_alarm_progress', {
				default: 'Arming in Progress',
			})}
	{showModal}
	on:close={onCloseModal}
>
	<Container slot="content" padding="0">
		<div class="d-flex justify-content-center mb-s">
			<Icon
				size="xxl"
				icon={isAllArmed ? 'fal fa-circle-check text-success' : 'fal fa-timer text-primary'}
			/>
		</div>

		<div class="d-flex justify-content-center text-center mb-m">
			<Text styleType="h1">
				{isAllArmed
					? $format('label_all_alarms_armed_successfully', {
							default: 'All alarms armed successfully!',
						})
					: $format('label_some_alarms_delay', {
							default: 'Some alarms will arm immediately, others will have a delay.',
						})}
			</Text>
		</div>
		<Stack gap="xs">
			{#each allAlarms as alarm}
				<ListItem
					class="bg-color-1"
					title={alarm._meta.name}
					image={alarm._meta.image && load_image_from(alarm._meta.image)}
					backgroundColor={alarm._meta.backgroundColor}
					progress={{
						showPercentBar: false,
						title:
							alarm._enabled && alarm?._meta?._time_trigger && alarm?._enable_delay
								? formatSecsToTimeString(alarmsDelayTimer[alarm.id])
								: alarm._enabled
									? $format('label_alarm_armed', {
											default: 'Armed',
										})
									: '',
						color: 'white',
						icon:
							(alarm._enabled && !alarm?._meta?._time_trigger) ||
							(alarm._enabled && !alarm?._enable_delay)
								? 'fa-solid fa-circle-check text-success'
								: alarm._enabled && alarm?._meta?._time_trigger
									? 'fas fa-timer text-primary'
									: '',
					}}
				/>
			{/each}
		</Stack>
		<div class="d-flex justify-content-center mt-l">
			<Button on:click={onCloseModal}>
				{$format('button_got_it_no_sign', { default: 'Okay, got it' })}
			</Button>
		</div>
	</Container>
</Modal>
